/* tslint:disable */
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class MathService {

    constructor() {
    }

    radianToDegree(rad) {
        return rad * (180 / Math.PI);
    }

    degreeToRad(degree) {
        return degree * (Math.PI / 180);
    }
}
